<button type="button" class=" position-relative btn-icon">
  <i class="bi {{iconBootstrap}}" *ngIf="iconBootstrap"></i>
  <so-icon  [icon]="icon" [svg]="svg" [size]="sizeIcon" />
  <span class="position-absolute translate-middle badge rounded-pill bg-danger-seekop badge-seekop" *ngIf="text">
    {{text}}
    <span class="visually-hidden">unread messages</span>
  </span>
</button>
